import React from 'react';
import { SPECIALTIES, isListedSpecialty } from '../lib/specialties';
import { palette as T, alpha, type } from '../design';

// Specialties picker (IW-3). Replaces a free-text field whose typed values never matched the
// marketplace chips, so students filtering "JLPT prep" missed instructors who wrote "jlpt".
//
// Each listed specialty is a toggle chip. A specialty typed before the list existed stays as a
// removable chip: dropping it silently would change a live profile. There is no text input,
// so nothing off the list can be added.

const font = "'Plus Jakarta Sans', sans-serif";

const chipStyle = (active) => ({
  padding: '6px 12px', borderRadius: 9999, border: '1px solid',
  borderColor: active ? T.terracotta : T.border,
  background: active ? alpha('terracotta', 'hover') : 'transparent',
  color: active ? T.terracottaDeep : T.walnut,
  fontFamily: font, fontSize: type.body, fontWeight: active ? 600 : 400, cursor: 'pointer',
});

export function SpecialtyPicker({ value = [], onChange, labelId }) {
  const unlisted = value.filter((s) => !isListedSpecialty(s));
  const toggle = (name) => onChange(value.includes(name) ? value.filter((s) => s !== name) : [...value, name]);
  const remove = (name) => onChange(value.filter((s) => s !== name));

  return (
    <div>
      <div role="group" aria-labelledby={labelId} style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
        {SPECIALTIES.map((name) => {
          const active = value.includes(name);
          return (
            <button key={name} type="button" aria-pressed={active} onClick={() => toggle(name)} style={chipStyle(active)}>
              {name}
            </button>
          );
        })}
      </div>
      {unlisted.length > 0 && (
        <div style={{ marginTop: 10 }}>
          <p style={{ fontFamily: font, fontSize: type.label, color: T.driftwood, margin: '0 0 6px' }}>
            Not on the list. Students still see these on your profile, but no filter finds them.
            Pick from the list above so students can find you.
          </p>
          <ul style={{ display: 'flex', flexWrap: 'wrap', gap: 6, listStyle: 'none', margin: 0, padding: 0 }}>
            {unlisted.map((name) => (
              <li key={name} style={{ display: 'inline-flex', alignItems: 'center', gap: 2, padding: '0 0 0 12px', borderRadius: 9999, background: T.warmGrey, fontFamily: font, fontSize: type.body, color: T.walnut }}>
                {name}
                {/* 32x32 tap target: the remove button is pressed on phones (IW-3 review). */}
                <button type="button" aria-label={`Remove ${name}`} onClick={() => remove(name)}
                  style={{ minWidth: 32, minHeight: 32, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', border: 'none', borderRadius: 9999, background: 'transparent', color: T.driftwood, cursor: 'pointer', fontSize: type.lead, lineHeight: 1, padding: 0 }}>
                  <span aria-hidden="true">×</span>
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
